import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import InfoCard from './InfoCard.js';
import { Marker as Marker$2 } from './style.js';
import { jsx } from 'react/jsx-runtime';
import useIsGlobetrotter from '../../hooks/useIsGlobetrotter.js';

var _excluded = ["$dimensionKey", "$geoService", "$getDimensions", "$hover", "animated", "children", "onClick", "selected", "type"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Marker = function Marker(_ref) {
  var $dimensionKey = _ref.$dimensionKey,
    $geoService = _ref.$geoService,
    $getDimensions = _ref.$getDimensions,
    _ref$$hover = _ref.$hover,
    $hover = _ref$$hover === void 0 ? false : _ref$$hover,
    _ref$animated = _ref.animated,
    animated = _ref$animated === void 0 ? false : _ref$animated,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? undefined : _ref$children,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'hotel' : _ref$type,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isGlobetrotter = useIsGlobetrotter();
  var infoCardPosition = 'top-center';
  if (/*#__PURE__*/React.isValidElement(children) && children.type === InfoCard) {
    var mapWidth = $geoService.getWidth();
    var markerDim = $getDimensions($dimensionKey);
    var markerHeight = selected ? 46 : 38;
    var infoCardHeight = 305;
    var infoCardWidth = 272;
    var infoCardPositionY = markerDim.y > infoCardHeight + markerHeight ? 'top' : 'bottom';
    var infoCardPositionX;
    if (markerDim.x > infoCardWidth / 2 && markerDim.x < mapWidth - infoCardWidth / 2) infoCardPositionX = 'center';else if (markerDim.x < infoCardWidth / 2) infoCardPositionX = 'right';else infoCardPositionX = 'left';
    infoCardPosition = "".concat(infoCardPositionY, "-").concat(infoCardPositionX);
  }
  var childrenWithProps = React.Children.map(children, function (child) {
    if (/*#__PURE__*/React.isValidElement(child)) {
      var propsObj = {
        hidden: !$hover
      };
      if (child.type === InfoCard) propsObj = _objectSpread(_objectSpread({}, propsObj), {}, {
        $position: infoCardPosition,
        $markerSelected: selected
      });
      return /*#__PURE__*/React.cloneElement(child, propsObj);
    }
    return child;
  });
  return /*#__PURE__*/jsx(Marker$2, _objectSpread(_objectSpread({}, rest), {}, {
    // @ts-ignore
    $type: type,
    onClick: onClick,
    $isHovered: $hover,
    $isSelected: selected,
    $disableAnimation: !animated,
    $isGlobetrotter: isGlobetrotter,
    children: childrenWithProps
  }));
};
var Marker$1 = Marker;

export { Marker$1 as default };
//# sourceMappingURL=Marker.js.map
